const heroImage = {
  key: 'heroImage',
  componentKey: 'image',
  label: 'Hero Image'
};

export default heroImage;
